export default {
    'draft': 'info',
    'pendingReview': 'info',
    'inReview': 'info',
    'reviewed': '',
    'waitingDeveloperPublish': '',
    'published': '',
    'preOrder': '',
    'removed': 'warning',
    'rejected': 'warning',
    'unpublished': 'warning',
    'developerRejected': 'warning'
}
